import { useDispensaryContext } from '../lib/dispensaries/hooks/useDispensaryContext'
import useSiteSettings, { UseSiteSettings } from './useSiteSettings'

export type UseSiteFrontPage = NonNullable<UseSiteSettings>['frontpage']

const useSiteFrontPage = (): UseSiteFrontPage => {
  const sanitySiteSettings = useSiteSettings()
  const dispensary = useDispensaryContext()
  const frontPage = sanitySiteSettings?.frontpage
  const dispensaryFrontPage = sanitySiteSettings?.dispensaryFrontpage
  return dispensary ? dispensaryFrontPage || frontPage : frontPage
}

export default useSiteFrontPage
